import React from "react";
import SflLogo from "../../assets/ui_revamp/SFL.svg";
import { Flex, Typography } from "antd";
import { Link } from "react-router-dom";

const NotFound = ({ type }) => {
  return (
    <Flex
      justify="center"
      align="center"
      className="h-100 loading-screen notfound-screen"
      vertical
    >
      <img src={SflLogo} alt="SFL Logo" className="loading-sfl-logo notfound-sfl-logo" />
      <Typography.Paragraph className="loading-status-text notfound-status-text">
        {type === "token"
          ? "You are trying to access Designer tool with an invalid token. We recommend to first login to your SightFlight CRM and then click Designer Tool to access it."
          : "You are trying to access Designer  tool with an invalid UUID. We recommend to first login to your SightFlight CRM and then click Designer Tool to access it."}
      </Typography.Paragraph>
      <Link to={"/"} className="loading-back-button">
        Back to CRM
      </Link>
      <Typography.Text className="loading-footer">@SightFlight Team</Typography.Text>
      <Typography.Text className="loading-description notfound-description">
        SightFlight creates high-end roofing and solar software tools that aim to manage projects
        easier than before.
      </Typography.Text>
    </Flex>
  );
};

export default NotFound;
